export const baseCrmURL = 'https://crm.shoshanim.net';
